export default __webpack_public_path__ + "static/media/image-ph-study-report-n-m.83e8dbea.webp";